var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsArray, IsDateString, IsString, IsUUID } from 'class-validator';
import { ExerciseDeviceItemFullSizeDto } from './exercise-device-item.full-size.dto.js';
export class ExerciseDeviceFullSizeDto {
    id;
    createdAt;
    updatedAt;
    nameSingular;
    namePlural;
    exerciseDeviceItems;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], ExerciseDeviceFullSizeDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], ExerciseDeviceFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], ExerciseDeviceFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], ExerciseDeviceFullSizeDto.prototype, "nameSingular", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], ExerciseDeviceFullSizeDto.prototype, "namePlural", void 0);
__decorate([
    IsArray(),
    Expose(),
    Type(() => ExerciseDeviceItemFullSizeDto),
    __metadata("design:type", Array)
], ExerciseDeviceFullSizeDto.prototype, "exerciseDeviceItems", void 0);
//# sourceMappingURL=exercise-device.full-size.dto.js.map